module.exports = __webpack_public_path__ + "77491679392ea96add6a18000bcd0882.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/sm-320.webp.png
// module id = 535
// module chunks = 0